const translations = {
    es: {
        // Tipos de sensores
        standalone: "Independiente",
        multiple: "Multiple",
        single: "Único",

        // Campos y etiquetas
        name: "Nombre",
        description: "Descripción",
        type: "Tipo",
        parameters: "Parámetros",
        actives: "Activos",
        active: "Activo",
        percentage: "Porcentaje (%)",

        // - -
        "confsens.name": "Sensor",
        "confsens.description": "Sensor que está activo (A ó B ambos secuencialmente)",
        "confsens.choice.a": "Sensor A",
        "confsens.choice.b": "Sensor B",
        "confsens.choice.ab": "Sensor AB",
        "confdist.name": "Distancia",
        "confdist.description": "Medición de corta distancia, larga o ambas.",
        "confdist.choice.c": "Corta",
        "confdist.choice.l": "Larga",
        "confdist.choice.cl": "Ambas",
        "saturation.name": "Saturación",
        "saturation.description": "Es el umbral de potencia de recepción. Por debajo de este umbral no se considerará la medida. Por defecto 15cm",
        "saturation.params": "(cm)",
        "hysteresis.name": "Histéresis",
        "hysteresis.description": "Distancia máxima a la que se eliminan las medidas espurias por rebotes múltiples en la zona de sombra",
        "hysteresis.params": "(cm)",
        "threshold.name.c": "Umbrales distancia Corta",
        "threshold.name.l": "Umbrales distancia Larga",
        "threshold.name": "Umbral",
        "threshold.description": "Límite sensor ultrasonidos (%)",

        // Sensores específicos
        power: "Potencia",
        "power.description": "Potencia del sensor ultrasonidos",
        // "vacuum": "Nivel Vacio",
        vacuum: "Vaciado Brusco",
        "vacuum.description": "Valor en % de caída para activar la alerta ",
        filling: "Nivel Llenado",
        "filling.description": "Porcentaje sobre el que se activa la alerta",

        // Mensajes
        accept: "Aceptar",
        "value.range": "El valor tiene que estar entre {min}-{max}",
    },
    en: {
        // Tipos de sensores
        standalone: "Standalone",
        multiple: "Multiple",
        single: "Single",

        // Campos y etiquetas
        name: "Name",
        description: "Description",
        type: "Type",
        parameters: "Parameters",
        actives: "Actives",
        active: "Active",
        percentage: "Percentage (%)",

        // - -
        "confsens.name": "Sensor",
        "confsens.description": "Sensor that is active (A or B sequentially)",
        "confsens.choice.a": "Sensor A",
        "confsens.choice.b": "Sensor B",
        "confsens.choice.ab": "Sensor AB",
        "confdist.name": "Distance",
        "confdist.description": "Short, long or both distance measurement.",
        "confdist.choice.c": "Short",
        "confdist.choice.l": "Long",
        "confdist.choice.cl": "Both",
        "saturation.name": "Saturation",
        "saturation.description": "It is the threshold of power reception. Below this threshold, the measurement will not be considered. Default 15cm",
        "saturation.params": "(cm)",
        "hysteresis.name": "Hysteresis",
        "hysteresis.description": "Maximum distance to which the measurements are removed by multiple bounce in the shadow zone",
        "hysteresis.params": "(cm)",
        "threshold.name.c": "Short distance threshold",
        "threshold.name.l": "Long distance threshold",
        "threshold.name": "Threshold",
        "threshold.description": "Sensor ultrasonic threshold (%)",

        // Sensores específicos
        power: "Power",
        "power.description": "Ultrasonic sensor power",
        vacuum: "Abrupt Emptying",
        "vacuum.description": "Value in % drop to activate the alert",
        filling: "Filling Level",
        "filling.description": "Percentage at which the alert is activated",

        // Mensajes
        accept: "Accept",
        "value.range": "Value must be between {min}-{max}",
    },
};

export default translations;
